import { create } from 'zustand'
import { getProfiles, getAccessProfileById, savePermissions, addNewProfile, deleteProfile } from './provider'

import type { UseAccessProfileProps } from './types'

export const useAccessProfile = create<UseAccessProfileProps>((set) => ({
  profilesData: null,
  setProfilesData: (data) => set({ profilesData: data }),

  isProfilesLoading: false,
  setIsProfilesLoading: (value) => set({ isProfilesLoading: value }),

  accessProfileByIdData: null,
  setAccessProfileByIdData: (data) => set({ accessProfileByIdData: data }),

  isAccessProfileByIdLoading: false,
  setIsAccessProfileByIdLoading: (value) => set({ isAccessProfileByIdLoading: value }),

  isSavePermissionsLoading: false,
  setIsSavePermissionsLoading: (value) => set({ isSavePermissionsLoading: value }),

  isAddNewProfileLoading: false,
  setIsAddNewProfileLoading: (value) => set({ isAddNewProfileLoading: value }),

  isDeleteProfileLoading: false,
  setIsDeleteProfileLoading: (value) => set({ isDeleteProfileLoading: value }),

  getProfiles,
  getAccessProfileById,
  savePermissions,
  addNewProfile,
  deleteProfile
}))
